import React, { FC } from 'react';
import { CoreAdminContext, AdminContextProps } from 'ra-core';

import defaultI18nProvider from './defaultI18nProvider';

const AdminContext: FC<AdminContextProps> = ({ i18nProvider = defaultI18nProvider, ...props }) => (
    <CoreAdminContext i18nProvider={i18nProvider} {...props} />
);

AdminContext.displayName = 'AdminContext';

export default AdminContext;
